export const errorClass = (message?: string) => (message ? "has-feedback has-error" : "");

export const renderErrorIcon = (message?: string) =>
  message ? <span className="form-control-feedback rioglyph rioglyph-error-sign"></span> : null;

export const renderErrorFeedback = (message?: string) =>
  message && (
    <>
      <span className="form-control-feedback rioglyph rioglyph-error-sign"></span>
      <span className="help-block">
        <span>{message}</span>
      </span>
    </>
  );
